'use strict';

export class EvaluationBaseCtrl
{
	$scope;
	$filter;
	$timeout;
	jsDataService;
	notify;
	$mdDialog;
	evaluation = {};
	showRequire = false;
	
	cfg = {
		maxFileSize: 0,
		fileFilter: {},
		saveUrl: '',
		uploadUrl: '',
		removeUrl: ''
	};
	attachmentUploadUrl;
	attfile = {
		file: {}
	};
	dragClass = '';
	attachments = [];
	
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.cfg.fileFilter = this.jsDataService.get('cfgFileFilter', {});
		this.cfg.maxFileSize = this.jsDataService.get('maxFileSize', 0);
		this.cfg.saveUrl = this.jsDataService.get('cfgAttachmentSaveUrl');
		this.cfg.uploadUrl = this.jsDataService.get('cfgUploadUrl');
		this.cfg.removeUrl = this.jsDataService.get('cfgAttachmentRemoveUrl', '');
		this.postConstruct();
	}
	
	postConstruct(){
		
	}
	
	fileUploaded($file, $message, $flow){
		if($file.response.success){
			this.attfile.file.file_id = $file.response.fileId;
			this.attfile.file.done = true;
			this.saveAttachment(this.attfile);
		}
	}
	
	filesAdded($files){
		return true;
	}

	fileAdded($file){
		const ext = $file.getExtension();
		if(typeof(this.cfg.fileFilter[ext]) === 'undefined' || !this.cfg.fileFilter[ext]){
//			this.notify(this.$filter('tr')('file_wrong_format'), true);
			return false;
		}
		if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
			this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
			return false;
		}
		if(!this.activeUpload()){
			return false;
		}
		this.addFlowFile($file);
		return true;
	}
	
	fileSubmited(){
		this.attfile.flow.upload();
	}
	
	activeUpload(){
		return true;
	}

	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}

	classOffDrag(value){
		this.dragClass = value;
	}
	
	addFlowFile($file){
		let file = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.attfile.file = file;
	}
	
	saveAttachment(attachment){
		let data = {
			file_id: attachment.file.file_id,
			title: attachment.file.file_name
		};
		if(this.cfg.saveUrl && this.cfg.saveUrl !== ''){
			this.$scope.basicHttpConfigProcess({
				url: this.cfg.saveUrl,
				method: 'POST',
				data: data
			}).then((response) => {
				if(response.data.success && typeof(response.data.item) !== 'undefined'){
					this.attachments.push(response.data.item);
					this.attfile.file = {};
				}
			}, () => {});
		}
		else{
			console.log('no url ', this.cfg.saveUrl);
		}
	}
	
	removeAttachment(ev, attachment){
		if(this.cfg.removeUrl !== ''){
			const confirmTexts = this.jsDataService.get('attachmentRemoveConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.cfg.removeUrl,
					method: 'GET',
					responseType: 'json',
					params: {
						id: attachment.id
					}
				}).then((results) => {
					if(results.data.success){
						this.attachments = this.$filter('filter')(this.attachments, {id: '!'+attachment.id}, true);
					}
				});
			}, () => {});
		}
	}
}